export default "__VITE_ASSET__DKVMw8vG__"